import { gql, useMutation, useQuery } from '@apollo/client'

import {
  AutoFollowSettingsQuery,
  AutoFollowSettingsQueryVariables,
  UpdateUserFollowSettingsMutation,
  UpdateUserFollowSettingsMutationVariables,
} from '@/clients/utoniq-core/schema'
import { makeViewModel } from '@/core/architecture'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { data } = useQuery<
    AutoFollowSettingsQuery,
    AutoFollowSettingsQueryVariables
  >(QUERY)

  const [updateUserFollowSettings] = useMutation<
    UpdateUserFollowSettingsMutation,
    UpdateUserFollowSettingsMutationVariables
  >(UPDATE_USER_FOLLOW_SETTINGS)

  return {
    state: {
      autoFollow: !!data?.user?.settings?.follow?.autoFollow,
    },
    actions: {
      async onToggle(autoFollow) {
        await updateUserFollowSettings({
          variables: { inputs: { autoFollow } },
          optimisticResponse({ inputs }) {
            return {
              updateUserFollowSettings: {
                id: data?.user?.id ?? '',
                settings: {
                  follow: {
                    autoFollow: inputs.autoFollow,
                    __typename: 'Follow',
                  },
                  __typename: 'UserSettings',
                },
                __typename: 'User',
              },
            }
          },
        })
      },
    },
  }
})

const QUERY = gql`
  query AutoFollowSettings {
    user {
      id
      settings {
        follow {
          autoFollow
        }
      }
    }
  }
`

const UPDATE_USER_FOLLOW_SETTINGS = gql`
  mutation UpdateUserFollowSettings($inputs: UserFollowSettingsInput!) {
    updateUserFollowSettings(inputs: $inputs) {
      id
      settings {
        follow {
          autoFollow
        }
      }
    }
  }
`
